// Configuration Firebase pour le web
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyDloaCCvF8iH3wNHYbg0cc1sHLIkY3uJO4",
  authDomain: "oosmose-properties.firebaseapp.com",
  databaseURL: "https://oosmose-properties-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "oosmose-properties",
  storageBucket: "oosmose-properties.appspot.com",
  messagingSenderId: "467317703544",
  appId: "1:467317703544:web:403b82b8b0dced9e07be8d",
  measurementId: "G-J96HPSKNHB"
};

// Initialiser Firebase
const app = initializeApp(firebaseConfig);

// Initialiser l'authentification
const auth = getAuth(app);

// Initialiser Firestore avec la base de données 'propertyassist'
const db = getFirestore(app, 'propertyassist');

// Initialiser Storage
const storage = getStorage(app);

export { auth, db, storage };